module.exports = __webpack_public_path__ + "static/media/sc_40_i.19cbb678.png";